// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import ColoredBackgroundCard from "components/Cards/BackgroundCards/ColoredBackgroundCard";

// Import Images
import datacenter from "assets/images/datacenter.jpg";
import dashboard from "assets/images/default-dashboard.png";
import game from "assets/images/project-game-default.png";

function Roadmap() {
    return (
        <MKBox component="section" py={6}>
            <Container>
                <Grid
                    container
                    item
                    xs={12}
                    lg={8}
                    flexDirection="column"
                    textAlign="center"
                    mx="auto"
                    mb={3}
                    borderRadius="md"
                    shadow="md"
                >
                    <MKTypography
                        variant="body2"
                        color="info"
                        fontWeight="bold"
                        textTransform="uppercase"
                        textGradient
                    ></MKTypography>
                    <MKTypography variant="h1">The Silver Fox Projects</MKTypography>
                </Grid>
                <Grid container spacing={3} mt={4}>
                    <Grid item xs={12} md={6} lg={4}>
                        <ColoredBackgroundCard
                            color="dark"
                            image={datacenter}
                            label="Growth"
                            title="Create Validators"
                            description="The plan I envision in how we will expand into the cosmos!"
                            action={{
                                type: "internal",
                                route: "/projects/validators",
                                label: "More...",
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <ColoredBackgroundCard
                            color="dark"
                            image={dashboard}
                            label="Tools"
                            title="Dashboard, Stats, Charts, etc..."
                            description="Contributing to the community is important and here are a few of our projects lined up to do so!"
                            action={{
                                type: "internal",
                                route: "/projects/tools",
                                label: "More...",
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <ColoredBackgroundCard
                            color="dark"
                            image={game}
                            label="Utility"
                            title="Game"
                            description="A Pay, play, and earn game enspired by an old BBS Door game called LORD. This ain't your simple stake a nft kinda game!"
                            action={{
                                type: "internal",
                                route: "/projects/game",
                                label: "More...",
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default Roadmap;
